import { CallHistory } from "one-state-call-history";

export const TransformResponse = (response: any, context: any) => {
    let callHistoryData: Array<CallHistory> = [];
    let result: any = { callHistoryData: callHistoryData, error: undefined }
    if (response?.status >= 400 || response?.type === 'error') {
        result.error = response;
    } 
    else if (response?.length > 0) {
        response.forEach((e: any) => {
            let callHistory: CallHistory = {};
            callHistory.timestamp = e['TIMESTAMP'] || '';
            callHistory.customerName = e['CUSTOMER NAME'] || '';
            callHistory.ani = e['ANI'] || '';
            callHistory.agentName = e['AGENT NAME'] || '';
            callHistory.dnis = e['DNIS'] || '';
            callHistory.callTime = e['CALL TIME'] || '';
            callHistory.holdTime = e['HOLD TIME'] || '';
            callHistory.disposition = e['DISPOSITION'] || '';
            callHistory.calls = e['CALLS'] || '';
            callHistory.callType = e['CALL TYPE'] || '';
            callHistory.notes = e['NOTES'] || '';
            callHistoryData.push(callHistory);
        });
    }
    result.callHistoryData = callHistoryData;
    return result;
}